import { render, staticRenderFns } from "./PowerTopology.vue?vue&type=template&id=0aa45be0"
import script from "./PowerTopology.vue?vue&type=script&lang=js"
export * from "./PowerTopology.vue?vue&type=script&lang=js"
import style0 from "./PowerTopology.vue?vue&type=style&index=0&id=0aa45be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports